import "react-loading-skeleton/dist/skeleton.css";
import MessagingModule from "../../component/chatbot/MessagingModule";

const UserCommunication = () => {
  return (
    <>
      {/* <div className="dbCon">
        <div className="dbRight"> */}
      <div className="table m-0">
        <MessagingModule />
      </div>
      {/* </div>
      </div> */}
    </>
  );
};

export default UserCommunication;
